import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  queryKey: string;
  codigoSapEmpreendimento?: string | null;
  nomeBlocoEmpreendimento?: string | null;
}

export function useListarUnidadesFunil(props: Props) {
  const fetchData = async () => {
    if (!props.codigoSapEmpreendimento || !props.nomeBlocoEmpreendimento) {
      return {
        data: [],
        pagination: null,
      };
    }

    const codigoSapEmpreendimento = encodeURIComponent(
      props.codigoSapEmpreendimento
    );
    const nomeBlocoEmpreendimento = encodeURIComponent(
      props.nomeBlocoEmpreendimento
    );

    const LISTAR_UNIDADES = `${backofficeEnviroment}/common/oportunidades-lead/listar-unidades/v1/${codigoSapEmpreendimento}/${nomeBlocoEmpreendimento}`;

    const response = await instance.get(LISTAR_UNIDADES);
    return {
      data: response?.data?.data || [],
      pagination: response?.data?.pagination || null,
    };
  };

  return useQuery({
    queryFn: fetchData,
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: false,
  });
}
